var origTables;
var date = new Date(); 
$(document).ready(function(){
	if ($("html").attr("data-bank") == "VUB") {
		var tables = $("div[data-type-table]");
		origTables = tables.clone();
		$(tables).each(function(index){
			var table = $(this);
			var tableType = table.attr("data-type-table");
			var endpoint;
			if(tableType != "euribor"){
				date = new Date();
				
				var startingDate = formatDate(date);
				endpoint = $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + "&fromCurrency=EUR&toCurrency=&datePickerStart="+startingDate+"&datePickerStop="+startingDate+"";;	
			}else{
				endpoint = $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val();
			}			
			getJsonAjaxVub(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType);
			
			
		});
	}


});
createTablesVub = function(tableType){
	
	var codeLabel =  $("data-label-code").val();
	var currencyLabel = $("data-label-currency").val();
	var rateLabel = $("data-label-rate").val();
	var hiddenColumnCode = $("#data-ecb-hiddend-column-code").val();
	var hiddenColumnCurrency = $("#data-ecb-hiddend-column-currency").val();
	var hiddenColumnRate = $("#data-ecb-hiddend-column-rate").val();
	var lang= $("html").attr("lang");
	var table = $("div[data-type-table="+tableType+"]");
	var indexForEcbArchive = 0;
	var json = $("#exchange-rates-"+tableType.toLowerCase()).val();
		if(json != ""){
			var obj = JSON.parse(json);

			var clonedTable = table.clone();
			var columnsList = table.find("ul.tbl2__highlist");
			var columnsRow = columnsList.find("li.tbl2__highlistItem");
			var columnsRowList = columnsRow.find("ul.tbl__highlist");
			var columns = columnsRowList.find("li.tbl__highlistItem");
			var totalColumns;
			columnsRowList.html("");
			columnsList.html("");
			
			if(tableType == 'ATM-DCC'){
				
				date = new Date(obj.rates[0].defined);
				
				updateDateLabel(date);
				
				totalColumns = 2;
				$.each(obj.rates, function(key, value) {
						var clonedRow = columnsRow.clone();
						
						var jsonValue = value;
						var columnsRowListCloned = columnsRowList.clone();
						var valueResult ="";
						var valueResultLabel = "";
						var currencyFromLabel = jsonValue.fromCurrency.label.toUpperCase();
						var currencyTo = jsonValue.toCurrency;
						var currencyToLabel = currencyTo.label.toUpperCase();
						var currencyRate = jsonValue.meanRate.rate.toString().replace(".", ",");
					/* var currencyTo = jsonValue.toCurrency;
						var currencyToLabel = currencyTo.label;*/
						if(currencyFromLabel === currencyToLabel) return;
						
							for(i = 0; i <totalColumns; i++){
								var cloned = columns.clone();
	
								switch(i) {
									case 0: 
                                    	var host = window.location.origin.length > 0 ? window.location.origin : null;
                                    	if(host != null){
                                        	valueResult = '<img alt = "" aria-hidden = "true" src="'+ host + '/' + getFlagImagePath(currencyToLabel) + '">' + currencyToLabel;
                                        }else{
                                        	valueResult = '<img alt = "" aria-hidden = "true" src="'+ getFlagImagePath(currencyToLabel) + '">' + currencyToLabel;
                                        }
										break;	   
									case 1:
										valueResult = currencyRate;
										break;
									default:
										valueResult = "";
								} 
							
								if(valueResult != ""){
									//cloned.html('<span class="tbl__highlistLabel">'+valueResultLabel+'</span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
									cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
									columnsRowListCloned.append(cloned);
									
								}
						
						}
						
							clonedRow.append(columnsRowListCloned);
							
			
						columnsList.append(clonedRow);
					});
			}else if(tableType == "euribor"){
				totalColumns = 2;
				for (var key in obj.euriborData){
					var clonedRow = columnsRow.clone();
					var columnsRowListCloned = columnsRowList.clone();
					var valueKey = key;
					var valueJson = obj.euriborData[key];
					if (valueKey != "dateRate"){
					valueKey = valueKey.replace("fix","");
					for(i = 0; i <totalColumns; i++){
						var cloned = columns.clone();
						switch(i) {
						case 0:
							valueResult = valueKey;	 
							break;
						case 1: 
							valueResult = valueJson;
							break;	   
						default:
						valueResult = "";
						}		   		    		
						if(valueResult != ""){
						cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
						columnsRowListCloned.append(cloned);
						}
					}
					clonedRow.append(columnsRowListCloned);
					columnsList.append(clonedRow);
					}else{
						$(".-js-date-exchange-euribor").html(valueJson);
					}
				
				}
				
			}
		json2xmlVub(tableType, null);
	}
}




calculateRateFormulas = function(sellingRate, fromRates, toRates, currency){
	result = 0;	
	
		if(currency == "EUR"){
			result = (sellingRate/fromRates - 1 ) * 100;
			


		}else if (currency == "HUF" || 
				currency == "DKK" || 
				currency == "SEK" || 
				currency == "PLN" ||
				currency == "CZK" ||
				currency == "RON" ||
				currency == "HRK" ||
				currency == "NOK" ||
				currency == "CHF" 
				) {
			
		
			result = (sellingRate / (fromRates/toRates) -1 ) * 100;
			
			
		} else {
			return "-";
		}
	return Number(result).toFixed(2) + "%";
	
}

clearTable = function(tableType){
	
	$(origTables).each(function(index){
		if($(this).attr("data-type-table") == tableType){
			$("div[data-type-table="+tableType+"]").html('');
			$("div[data-type-table="+tableType+"]").html($(this).html());
		}
	});
}

getArchiveVUB = function (element, datePickerId, tableType) {
	var datePicker = $("#"+datePickerId);
	var d = new Date();
	var selectedDate = datePicker.val().slice(0,10).split(".").join("/")
	date = new Date(datePicker.val());
	

	var startingDate = formatDate(formatSlashedDate(selectedDate));
	var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + "&fromCurrency=EUR&toCurrency=&datePickerStart="+startingDate+"&datePickerStop="+startingDate+"";
	clearTable(tableType);
	var isArchive = true;
	getJsonAjaxControlVub(endpoint, element, tableType, isArchive, datePickerId, startingDate, 0);
}


getJsonAjaxVub = function (endpoint, element, tableType){
	
	$.ajax({
		method: "GET",
		url: endpoint
		})
		.done(function( data ) {
			if(data != null){
				
				$(element).val(JSON.stringify(data));
				
				createTablesVub(tableType);
			}
		});
}

getJsonAjaxControlVub = function (endpoint, element, tableType, isArchive, datePickerId, startingDate, counter){
	
	$.ajax({
		method: "GET",
		url: endpoint
		})
		.done(function( data ) {
			if(data != null && JSON.parse(JSON.stringify(data)).statusCode == 200){
				
				var datePicker = $("#"+datePickerId);
				var d = new Date();
				var startDate = startingDate;
				//formatDate(formatSlashedDate(datePicker.val().slice(0,10).split(".").join("/")))
				var endpoint = /*window.location.origin +*/ $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + "&fromCurrency=EUR&toCurrency=&datePickerStart="+startDate+"&datePickerStop="+startDate+"";
				clearTable(tableType);
				var isArchive = true;
				getJsonAjaxVub(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType, isArchive, datePickerId);
			} else if(data != null){
				if(counter < 10){
					counter = counter + 1;
					var startDate = new Date(startingDate);
					startDate.setDate(startDate.getDate() -1);
					var formattedDate = formatDate(startDate);
					var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + "&fromCurrency=EUR&toCurrency=&datePickerStart="+formattedDate+"&datePickerStop="+formattedDate+"";
					getJsonAjaxControlVub(endpoint, element, tableType, isArchive, datePickerId, formattedDate, counter);
				}
			}
		});
}
function formatDate(date) {
	var d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) 
		month = '0' + month;
	if (day.length < 2) 
		day = '0' + day;

	return [year, month, day].join('-');
}

function downloadFile(element){
	var fileContent = decodeURIComponent($(element).attr("data-download"));
	var fileName = 'download.xml';

	var blob = new Blob([fileContent], { type: 'text/plain' });
	var a = document.createElement('a');
	a.setAttribute('download', fileName);
	a.setAttribute('href', window.URL.createObjectURL(blob));
	a.click();
} 

function json2xmlVub(tableType,config) {
	config = config || {};
	initConfigDefaults();
	var jsonObj = JSON.parse($("#exchange-rates-"+tableType.toLowerCase()).val());
	var out = '<?xml version="1.0" encoding="utf-8"?>' + parseJSONObject(jsonObj);
	$(".js-xml-"+tableType+"").attr("data-download", encodeURIComponent(out)); 
	function initConfigDefaults() {
		if(config.escapeMode === undefined) {
			config.escapeMode = true;
		}
		config.attributePrefix = config.attributePrefix || "_";
		config.arrayAccessForm = config.arrayAccessForm || "none";
		config.emptyNodeForm = config.emptyNodeForm || "text";
		if(config.enableToStringFunc === undefined) {
			config.enableToStringFunc = true; 
		}
		config.arrayAccessFormPaths = config.arrayAccessFormPaths || []; 
		if(config.skipEmptyTextNodesForObj === undefined) {
			config.skipEmptyTextNodesForObj = true;
		}
		if(config.stripWhitespaces === undefined) {
			config.stripWhitespaces = true;
		}
		config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];
	}	
	function startTag(jsonObj, element, attrList, closed) {
		var resultStr = "<"+ ( (jsonObj!=null && jsonObj.__prefix!=null)? (jsonObj.__prefix+":"):"") + element+">";
		if(attrList!=null) {
			for(var aidx = 0; aidx < attrList.length; aidx++) {
				var attrName = attrList[aidx];
				var attrVal = jsonObj[attrName];
				if(config.escapeMode)
					attrVal=escapeXmlChars(attrVal);
				resultStr+=" "+attrName.substr(config.attributePrefix.length)+"='"+attrVal+"'";
			}
		}
		if(!closed)
			resultStr+="";
		else
			resultStr+="";
		return resultStr;
	}
	
	function endTag(jsonObj,elementName) {
		return "</"+ (jsonObj.__prefix!=null? (jsonObj.__prefix+":"):"")+elementName+">";
	}
	
	function endsWith(str, suffix) {
		return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
	function getNodePrefix(node) {
		return node.prefix;
	}
		
	function escapeXmlChars(str) {
		if(typeof(str) == "string")
			return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2F;');
		else
			return str;
	}

	function unescapeXmlChars(str) {
		return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&#x2F;/g, '\/');
	}
	
	function jsonXmlSpecialElem ( jsonObj, jsonObjField ) {
		if((config.arrayAccessForm=="property" && endsWith(jsonObjField.toString(),("_asArray"))) 
				|| jsonObjField.toString().indexOf(config.attributePrefix)==0 
				|| jsonObjField.toString().indexOf("__")==0
				|| (jsonObj[jsonObjField] instanceof Function) )
			return true;
		else
			return false;
	}

	function jsonXmlElemCount ( jsonObj ) {
		var elementsCnt = 0;
		if(jsonObj instanceof Object ) {
			for( var it in jsonObj  ) {
				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;			
				elementsCnt++;
			}
		}
		return elementsCnt;
	}
	
	function parseJSONObject ( jsonObj ) {
		var result = "";

		var elementsCnt = jsonXmlElemCount ( jsonObj );
		
		if(elementsCnt > 0) {
			for( var it in jsonObj ) {
				
				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;			
				
				if(it.toUpperCase() != "STATUSCODE" && it.toUpperCase() != "STATUSMESSAGE"  ){
					
				var subObj = jsonObj[it];						
				
				var attrList = parseJSONAttributes( subObj )
				
				console.log("attrList:",attrList);
				
				console.log("subObj",subObj);
				
				
				
				if(subObj == null || subObj == undefined) {
				}
				else
				if(subObj instanceof Object) {
					
					if(subObj instanceof Array) {			
						result += "<exRate>"
						result+=parseJSONArray( subObj, it, attrList );		
						result += "</exRate>"
					}
					else if(subObj instanceof Date) {
						result+=startTag(subObj, it, attrList, false);
						result+=subObj.toISOString();
						result+=endTag(subObj,it);
					}
					else {
						var subObjElementsCnt = jsonXmlElemCount ( subObj );
						if(subObjElementsCnt > 0 || subObj.__text!=null || subObj.__cdata!=null) {
							result+=startTag(subObj, it, attrList, false);
							result+=parseJSONObject(subObj);
							result+=endTag(subObj,it);
						}
						else {
							result+=startTag(subObj, it, attrList, true);
						}
					}
				}
				else {
					result+=startTag(subObj, it, attrList, false);
					result+=parseJSONTextObject(subObj);
					result+=endTag(subObj,it);
				}
			}
			}
			
		}
		result+=parseJSONTextObject(jsonObj);
		
		return result;
	}
	function parseJSONAttributes ( jsonObj ) {
		var attrList = [];
		if(jsonObj instanceof Object ) {
			for( var ait in jsonObj  ) {
				if(ait.toString().indexOf("__")== -1 && ait.toString().indexOf(config.attributePrefix)==0) {
					attrList.push(ait);
				}
			}
		}
		return attrList;
	}
	
	function parseJSONTextAttrs ( jsonTxtObj ) {
		var result ="";
		
		if(jsonTxtObj.__cdata!=null) {										
			result+="<![CDATA["+jsonTxtObj.__cdata+"]]>";					
		}
		
		if(jsonTxtObj.__text!=null) {			
			if(config.escapeMode)
				result+=escapeXmlChars(jsonTxtObj.__text);
			else
				result+=jsonTxtObj.__text;
		}
		return result;
	}
	
	function parseJSONTextObject ( jsonTxtObj ) {
		var result ="";

		if( jsonTxtObj instanceof Object ) {
			result+=parseJSONTextAttrs ( jsonTxtObj );
		}
		else
			if(jsonTxtObj!=null) {
				if(config.escapeMode)
					result+=escapeXmlChars(jsonTxtObj);
				else
					result+=jsonTxtObj;
			}
		
		return result;
	}
	
	function parseJSONArray ( jsonArrRoot, jsonArrObj, attrList ) {
		var result = ""; 
		if(jsonArrRoot.length == 0) {
			result+=startTag(jsonArrRoot, jsonArrObj, attrList, true);
		}
		else {
			for(var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
				result+=startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
				result+=parseJSONObject(jsonArrRoot[arIdx]);
				result+=endTag(jsonArrRoot[arIdx],jsonArrObj);						
			}
		}
		return result;
	}

}

function formatSlashedDate(date){
	var dateString = date; // Oct 23

	var dateParts = dateString.split("/");

	// month is 0-based, that's why we need dataParts[1] - 1
	var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
	
	return dateObject.toDateString();
}

function updateDateLabel(date) {
	if(dateIsValid(date)) {
		var formattedDate =  addLeadingZeros(date.getDate()) + "." + addLeadingZeros(date.getMonth() + 1) + "." + date.getFullYear();
		
		$('.-js-date-dcc').html(formattedDate);
	}
}

function addLeadingZeros(n) {
	if (n <= 9) {
		return "0" + n;
	}
	return n
}

function dateIsValid(date) {
	return !(isNaN(date.getDate) && isNaN(date.getMonth) && isNaN(date.getFullYear()));
}

function getFlagImagePath(country) {
	return '.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/country_icons/'+ country.toLowerCase() +'.gif';
}
